/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';

export default function CourseFeatures({ heading, subheading = '', courseFeatures }) {
  return (
    <section className="w-full bg-[#d2e9ff30] flex flex-col items-center gap-[30px] sm:gap-[35px] md:gap-[40px] px-[30px] sm:px-[38px] md:px-[46px] py-[30px] sm:py-[38px] md:py-[46px] sm:mt-[20px] md:mt-[10px]">

      {/* <header className="flex flex-col items-center gap-[6px]">
        <div className="flex items-center gap-[12px]">
          <div className="w-[6px] h-[32px] bg-[#ff5761]" />
          <h2 className="text-[22px]  font-medium leading-[33px] text-black">
            {heading}
          </h2>
        </div>
        {subheading && (
        <h3 className="text-[30px]  font-semibold leading-[45px] text-black text-center">
          {subheading}
        </h3>
        )}
      </header> */}
      {
        (heading || subheading)
        && (
        <div className="w-full flex flex-col items-center text-center mb-1">
          {heading && <div dangerouslySetInnerHTML={{ __html: heading }} />}
          {subheading && <div dangerouslySetInnerHTML={{ __html: subheading }} />}
        </div>
        )
       }

      <div className="w-full max-w-[1318px] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[34px]">
        {courseFeatures?.map((feature, index) => (
          <div
            key={index}
            className="relative flex flex-col items-center w-full bg-white border border-[#b7e5ff] rounded-[10px] shadow-sm px-[14px] py-[24px] text-center"
          >
            <div className="absolute -top-[32px] flex items-center justify-center w-[64px] h-[64px] rounded-full bg-[#38AFFF] shadow-[-1px_3px_7px_#9ad6ff93] border-2 border-white">
              <img src={feature?.image} alt={feature?.name} className="w-10 h-10" />
            </div>

            <p className="mt-[40px] text-[16px]  font-semibold leading-[24px] text-black">
              {feature?.name}
            </p>
            <div
              className="mt-2 text-[14px]  font-normal leading-[20px] text-[#000000]"
              dangerouslySetInnerHTML={{ __html: feature?.description }}
            />
          </div>
        ))}
      </div>
    </section>
  );
}

CourseFeatures.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  courseFeatures: PropTypes.array,
};
